import { isFilledObject } from '../../AppHelpers'
import PlaylistItemAsset from './PlaylistItemAsset'

export default class PlaylistAsset {
  constructor(obj) {
    this._isFilled = isFilledObject(obj) && obj.items && obj.items.length > 0

    this.playlistItems = []

    this.title = obj.title
    this.type = 'playlist' //obj.type;

    this.CoverImage = ''

    if (obj && obj.items && obj.items.length > 0) {
      obj.items = obj.items.slice(0, 5) // TODO limiting to 5 items in a list
      this.playlistItems = obj.items.map(itm => {
        return new PlaylistItemAsset(itm)
      })

      this.CoverImage = this.playlistItems[0].image
    }
  }
}
